import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import SelectFile from './SelectFile/SelectFile';
import ErrorList from './ErrorList/ErrorList';
import styles from './CSVModal.module.css';

const AddSkusScreen = ({
  confirmationScreen,
  selectedFile,
  skus,
  isAddingSkus,
  confirmed,
  productsNumber,
  campaign,
  error,
  onSelectFile,
  onClearState,
  onChangeSkus,
  onChangeConfirm,
  onClose,
  onClickNext,
  onSubmit,
}) => {
  const value = get(error, 'value');
  const message = get(error, 'message');
  return (
    <div
      className={`
      ${styles.content} ${styles.contentLeft} ${styles.addProducts}
      ${error ? styles.error : ''}
    `}
    >
      <h1>Add Products</h1>
      <p className={styles.subtitle}>
        Add new products by uploading a CSV file <strong>or</strong> pasting
        their SKUs into the input field.
      </p>
      <div className={styles.contentContainer}>
        {!confirmationScreen && (
          <>
            <h3>Upload CSV</h3>
            <SelectFile
              file={selectedFile}
              disabled={!!skus}
              onSelect={onSelectFile}
              clear={onClearState}
            />
            {error && <p className={styles.error}>{error}</p>}
            <div className={styles.separator} />
            <h3>Paste Products</h3>
            <textarea
              placeholder="Paste one or more products SKUs separated by a comma"
              value={skus}
              onChange={onChangeSkus}
            />
            <div className={styles.separator} />
          </>
        )}
        {confirmationScreen && (
          <>
            {selectedFile && (
              <>
                <h3>Upload CSV</h3>
                <SelectFile
                  file={selectedFile}
                  disabled
                  error={!!error}
                  onSelect={onSelectFile}
                  clear={onClearState}
                />
                {error ? (
                  <p className={styles.error} style={{ marginBottom: 24 }}>
                    {message}
                  </p>
                ) : (
                  <div className={styles.separator} />
                )}
              </>
            )}
            {isAddingSkus && (
              <>
                <h3>Paste Products</h3>
                <textarea
                  placeholder="Paste one or more products SKUs separated by a comma"
                  value={skus}
                  onChange={onChangeSkus}
                  disabled={!error}
                />
                {error ? (
                  <p className={styles.error} style={{ marginBottom: 24 }}>
                    {message}
                  </p>
                ) : (
                  <div className={styles.separator} />
                )}
              </>
            )}
            {error ? (
              <>
                <h3>Fix the below errors before trying again:</h3>
                <ErrorList errorsList={value} style={{ maxHeight: 94 }} />
              </>
            ) : (
              <>
                <h3>Confirm Product Upload</h3>
                <label className={styles.checkbox} htmlFor="confirm">
                  <input
                    id="confirm"
                    name="confirm"
                    type="checkbox"
                    checked={confirmed}
                    onChange={onChangeConfirm}
                  />
                  <span className={styles.checkmark} />
                  {`I want to add ${productsNumber} ${
                    productsNumber === 1 ? 'product' : 'products'
                  } to ${campaign.name}.`}
                </label>
              </>
            )}
          </>
        )}
      </div>
      <div className={styles.buttons}>
        <Button
          onClick={onClose}
          buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
          style={{ width: 120 }}
        >
          Cancel
        </Button>
        {!confirmationScreen && (
          <Button
            onClick={onClickNext}
            style={{ width: 150 }}
            disabled={!selectedFile && !skus}
          >
            Next
          </Button>
        )}
        {confirmationScreen && error && (
          <Button onClick={onSubmit} style={{ width: 150 }}>
            Resubmit
          </Button>
        )}
        {confirmationScreen && !error && (
          <Button
            onClick={onSubmit}
            style={{ width: 150 }}
            disabled={!confirmed}
          >
            Submit
          </Button>
        )}
      </div>
    </div>
  );
};

AddSkusScreen.propTypes = {
  confirmationScreen: PropTypes.bool.isRequired,
  selectedFile: PropTypes.shape(),
  skus: PropTypes.string.isRequired,
  isAddingSkus: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  productsNumber: PropTypes.number.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  error: PropTypes.shape({
    message: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
  }),
  onSelectFile: PropTypes.func.isRequired,
  onClearState: PropTypes.func.isRequired,
  onChangeSkus: PropTypes.func.isRequired,
  onChangeConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

AddSkusScreen.defaultProps = {
  selectedFile: null,
  error: null,
};

export default AddSkusScreen;
